

























import Vue from 'vue';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';

const remark: string | null = null;

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      visible: false,
      remark,
      warning: false,
    };
  },
  computed: {
    submitRemarks(): string[] {
      const remarks = this.customerState.currentCustomer!.remarks;
      if (this.remark) {
        return remarks.concat(this.remark!);
      } else {
        return remarks;
      }
    },
  },
  methods: {
    submit() {
      if (!this.remark || (this.remark && this.remark!.trim()) === '') {
        this.warning = true;
        this.$Message.warning('签不能为空');
      } else {
        this.warning = false;
        customerClient.setRemarks({
          remarks: this.submitRemarks,
          openid: this.customerState.currentCustomer!.openid,
        }).success((r) => {
          this.$Message.success('新增标签成功');
          this.$store.commit('SET_CUSTOMER_REMAKRS', this.submitRemarks);
          this.remark = null;
          this.visible = false;
        }).failure((code: string, msg?: string) => {
          this.$Message.error(msg);
        }).error((e) => {
          this.$Message.error(e.toString());
        });
      }
    },
  },
});
